import { useTranslation } from 'react-i18next'
import type { Match, Team } from '@brochure/shared'
import { MatchCard } from './MatchCard'

type MatchListProps = { matches: Match[]; teams: Team[]; tournamentId: string }

/** Partite del girone, in ordine di `sortOrder` e numerate. */
export function MatchList({ matches, teams, tournamentId }: MatchListProps) {
  const { t } = useTranslation()
  if (matches.length === 0) return <p className="font-body text-sm text-ink-soft">{t('stoccoPong.group.empty')}</p>

  const sorted = [...matches].sort((a, b) => a.sortOrder - b.sortOrder)
  return (
    <ol className="grid max-w-3xl grid-cols-1 gap-2.5">
      {sorted.map((match, index) => (
        <li key={match.id}>
          <MatchCard match={match} teams={teams} tournamentId={tournamentId} number={index + 1} />
        </li>
      ))}
    </ol>
  )
}
